export const EVENTS = {
  SET_AMOUNT_TO_INVEST: 'SET_AMOUNT_TO_INVEST',
  SET_PRODUCT: 'SET_PRODUCT',
  SET_STRATEGY: 'SET_STRATEGY',
  SET_FOCUS: 'SET_FOCUS',
  SET_THEMATICS: 'SET_THEMATICS',
} as const
